import React from 'react';

interface GameLandingPanelProps {
  header: React.ReactNode;
  body: React.ReactNode;
  children?: React.ReactNode;
  className?: string;
}

const GameLandingPanel: React.FC<GameLandingPanelProps> = ({
  header,
  body,
  children,
  className = '',
}) => {
  return (
    <div
      className={`relative max-w-full overflow-hidden text-white text-center transition ${className}`}
      style={{
        width: '786px',
        maxWidth: '90vw',
        minHeight: 'auto',
        borderRadius: '30px',
        opacity: 0.85,
        background: 'linear-gradient(180deg, #31406E 0%, #2E3A66 100%)',
        boxShadow: '0 4px 4px 0 rgba(0, 0, 0, 0.25)',
      }}
    >
      <div className="absolute left-6 right-6 top-6 h-px bg-gradient-to-r from-transparent via-cyan-300/70 to-transparent shadow-[0_0_18px_rgba(95,208,255,0.55)]" />
      <div className="absolute left-6 right-6 bottom-8 h-px bg-gradient-to-r from-transparent via-cyan-300/70 to-transparent shadow-[0_0_18px_rgba(95,208,255,0.55)]" />

      <div className="relative z-10 flex flex-col items-center px-6 pt-8 pb-8 sm:px-12 sm:pt-12 sm:pb-12">
        <h1
          className="mb-6 max-w-full"
          style={{
            width: '100%',
            color: '#EAF2FF',
            textAlign: 'center',
            textShadow: '0 3.72px 37.2px rgba(95, 208, 255, 0.70)',
            fontFamily: 'Inter, system-ui, sans-serif',
            fontSize: 'clamp(25px, 8vw, 60px)',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: 'normal',
          }}
        >
          {header}
        </h1>

        <div className="w-full max-w-[88%] h-px mb-10 bg-gradient-to-r from-transparent via-cyan-300/60 to-transparent shadow-[0_0_16px_rgba(95,208,255,0.45)]" />

        <div
          className="mb-10 max-w-[92%]"
          style={{
            color: '#FFF',
            textAlign: 'center',
            fontFamily: 'Inter, system-ui, sans-serif',
            fontSize: 'clamp(15px, 3vw, 26px)',
            fontStyle: 'normal',
            fontWeight: 700,
            lineHeight: 'normal',
          }}
        >
          {body}
        </div>

        {children}
      </div>
    </div>
  );
};

export default GameLandingPanel;